import { Component, Input, OnInit } from "@angular/core";
import moment from "moment";
import { commonVar } from "../../../../providers/common-var/common";
@Component({
  selector: "creatinine-view-card",
  templateUrl: "creatinine-view-card.html",
})
export class CreatinineViewCardComponent implements OnInit {
  @Input() previousAssessment: any;

  ngOnInit(): void {
    this.previousAssessment.date = moment(this.previousAssessment.date).format(
      commonVar.DATE_FORMAT
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/creatinine-view-card/creatinine-view-card.ts